
/**
 * Module dependencies.
 */

import {
  authRequest,
  authorizationHeader,
  handleRequestError
} from 'src/core/utils/requests';

import { getAuthApiEndpoint } from 'src/core/utils/api-url-resolver';

/**
 * `Query` type.
 */

type Query = {
  token: string
};

/**
 * Export `resendConfirmAccount`.
 */

export async function resendConfirmAccount({ token }: Query) {
  const endpoint = getAuthApiEndpoint('resendConfirmAccount');

  if (!token) {
    return;
  }

  try {
    return await authRequest.post(endpoint, null, {
      headers: authorizationHeader(token)
    });
  } catch (error) {
    throw handleRequestError(error);
  }
}
